<template>
  <section :class="$style.community">
    <div class="container">
      <JoinHeading
        :level="2"
        class="text-center mb-7"
      >
        {{ $t('join.section.community.title') }}
      </JoinHeading>
    </div>

    <PageCollectionCarousel
      align="center"
    >
      <TestimonialContentBlock
        v-for="item in items"
        :key="item.name"
        :class="$style.item"
        :testimonial="item"
      />
    </PageCollectionCarousel>
  </section>
</template>

<script lang="ts">
import PageCollectionCarousel from '@/scripts/pages/onepager/components/PageCollectionCarousel.ts.vue';
import { JoinBaseComponent } from '../common/JoinBaseComponent';
import JoinHeading from '../common/JoinHeading.ts.vue';
import TestimonialContentBlock, { Testimonial } from '../common/testimonial-content-block.ts.vue';
import { CommunityImages } from '../assets/media';
import { LocaleItemWithSubtitle } from '../types/LocaleItem';

const itemImages = [
  CommunityImages.danielYam,
  CommunityImages.diegoBataraMahameru,
  CommunityImages.agungSentausa,
  CommunityImages.laurentCrouzeix,
  CommunityImages.jonahGarcia,
];

export default JoinBaseComponent.extend({
  components: {
    JoinHeading,
    TestimonialContentBlock,
    PageCollectionCarousel,
  },
  data() {
    const items: Testimonial[] = (this.$t('join.section.community.items') as LocaleItemWithSubtitle[])
      .map((item, index) => ({
        name: item.title,
        role: item.subtitle,
        logo: itemImages[index],
        quote: '“' + item.paragraphs.join('\n') + '”',
      }))
    ;

    return {
      items,
    };
  },
});
</script>

<style module lang="scss">
@import '~@/scripts/pages/onepager/styles/variables';

.community {
  background-color: $page-alternate-bg-color;
  padding-top: 6rem;
  padding-bottom: 9rem;
}

.item {
  $max-width: 268px;
  min-width: $max-width;
  max-width: $max-width;
  width: $max-width;

  $width: 320px;
  $min-width: 252px;
  $cal-width: $width - $min-width;
  $cal-expression: Min($max-width, calc(100vw - #{$cal-width}));

  min-width: $cal-expression;
  max-width: $cal-expression;
  width: $cal-expression;
}
</style>
